<template>
    <div class="card p-shadow-app">
        <h1>Cargas e Decargas - Guias de transporte</h1>
        <Toast />

        <div class="p-mb-3 p-d-flex p-jc-between p-ai-center">
            <Button
                class="p-mb-3"
                label="Registar nova morada"
                icon="pi pi-plus"
                @click="newAddress"
            />
        </div>

        <DataTable
            :value="list"
            :loading="loading"
            :paginator="true"
            :rows="perPage"
            :rowsPerPageOptions="[10, 20, 50, 100]"
            responsiveLayout="scroll"
            class="p-datatable-sm"
            stripedRows
            :filters.sync="filters"
            filterDisplay="row"
            :lazy="true"
            :totalRecords="totalRecords"
            @filter="fetchData"
            @sort="fetchData"
            @page="fetchData"
            scrollable
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Mostrar de {first} a {last} de {totalRecords} dados"
        >
            <template #empty>
                <div class="p-text-center p-p-3">
                    <p class="p-mt-2">Nenhum valor encontrado</p>
                </div>
            </template>

            <Column field="szadrsdesc" header="Descrição" :sortable="false" style="min-width: 150px">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText
                    v-model="filterModel.value"
                    class="p-column-filter"
                    @input="filterCallback()"
                    />
                </template>
            </Column>

            <Column field="nome" header="Nome" :sortable="false" style="min-width: 180px">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText
                    v-model="filterModel.value"
                    class="p-column-filter"
                    @input="filterCallback()"
                    />
                </template>
            </Column>

            <Column field="morada" header="Morada" :sortable="false" style="min-width: 200px">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText
                    v-model="filterModel.value"
                    class="p-column-filter"
                    @input="filterCallback()"
                    />
                </template>
            </Column>

            <Column field="codpost" header="Código Postal" :sortable="false" style="min-width: 200px">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText
                    v-model="filterModel.value"
                    class="p-column-filter"
                    @input="filterCallback()"
                    />
                </template>
            </Column>

            <Column field="pais" header="País" :sortable="false" style="min-width: 200px">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText
                    v-model="filterModel.value"
                    class="p-column-filter"
                    @input="filterCallback()"
                    />
                </template>
            </Column>

            <Column field="ousrdata" header="Data" :sortable="false" style="min-width: 120px">
                <template #body="slotProps">
                    {{ formatDate(slotProps.data.ousrdata) || '-' }}
                </template>
            </Column>

            <Column header="Ações" style="min-width: 150px">
                <template #body="slotProps">
                    <div class="p-d-flex p-gap-2">
                        <Button
                            icon="pi pi-pencil"
                            class="p-button-rounded p-button-info p-button-text"
                            v-tooltip.top="'Editar'"
                            @click="edit(slotProps.data)"
                        />
                    </div>
                </template>
            </Column>
        </DataTable>

        <DialogTransportDocumentForm
            :show="showForm"
            :data="formData"
            @close="showForm = false; formData = {}"
            @saved="fetchData(); showForm = false; formData = {}"
        />

    </div>
</template>

<script>
import transportDocumentService from '@/services/transport-document.service';
import { FilterMatchMode } from 'primevue/api';
import DialogTransportDocumentForm from './DialogTransportDocumentForm.vue';

export default {
    name: "TransportDocumentLocations",
    components: {
        DialogTransportDocumentForm
    },
    data() {
        return {
            list: [],
            loading: false,
            totalRecords: 0,
            currentPage: 1,
            perPage: 50,

            filters: {
                szadrsdesc: { value: null, matchMode: FilterMatchMode.CONTAINS },
                nome: { value: null, matchMode: FilterMatchMode.CONTAINS },
                morada: { value: null, matchMode: FilterMatchMode.CONTAINS },
                codpost: { value: null, matchMode: FilterMatchMode.CONTAINS },
                pais: { value: null, matchMode: FilterMatchMode.CONTAINS },
            },

            showForm: false,
            formData: {}
        };
    },

    created() {
        this.fetchData();
    },

    methods: {
        buildQueryParams(page = 1) {
            const params = new URLSearchParams();

            params.append('page', page);

            if (this.search) {
                params.append('search', this.search);
                return params;
            }

            for (const [key, filter] of Object.entries(this.filters)) {
                if (filter.value !== null && filter.value !== '') {
                params.append(`filters[${key}]`, filter.value);
                }
            }

            return params;
        },
        async fetchData(event = {}) {
            try {
                this.loading = true;

                const page = event.page ? event.page + 1 : 1;
                const params = this.buildQueryParams(page);
                params.append('per_page', event.rows || this.perPage);

                const response = await transportDocumentService.getTransportDocumentsLocations(params);

                this.list = response.data;
                this.totalRecords = response.meta.total;
                this.currentPage = response.meta.current_page;

            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao carregar dados',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },
        formatDate(dateString) {
            if (!dateString) return '-';

            const date = new Date(dateString);
            return date.toLocaleDateString('pt-PT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },
        edit(record) {
            this.formData = { ...record };
            this.showForm = true;
        },
        newAddress() {
            this.formData = {};
            this.showForm = true;
        }
    }
};
</script>

<style scoped>
.card {
    padding: 2rem;
}

h1 {
    margin-bottom: 1.5rem;
    color: #495057;
}

.p-field label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
}

dl {
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 0.5rem;
    margin: 0;
}

dt {
    font-weight: 600;
    color: #6c757d;
}

dd {
    margin: 0;
}

.confirmation-content {
    display: flex;
    align-items: center;
    padding: 1rem 0;
}

pre {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 4px;
    overflow-x: auto;
}

.p-gap-2 {
    gap: 0.5rem;
}
</style>